
import { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CharactersHeader } from "@/components/characters/CharactersHeader";
import { CharacterFilters } from "@/components/characters/CharacterFilters";
import { CharactersGrid } from "@/components/characters/CharactersGrid";
import { usePublicCharacters } from "@/hooks/usePublicCharacters";

const Characters = () => {
  const [speciesFilter, setSpeciesFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const { data: characters, isLoading, error } = usePublicCharacters({
    speciesFilter,
    roleFilter,
    searchTerm,
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-blue/10 to-teedee-blue/10">
      <Navbar />
      
      <main className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <CharactersHeader />
          
          <CharacterFilters
            speciesFilter={speciesFilter}
            setSpeciesFilter={setSpeciesFilter}
            roleFilter={roleFilter}
            setRoleFilter={setRoleFilter}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />

          <CharactersGrid
            characters={characters || []}
            isLoading={isLoading}
            error={error}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Characters;
